import React from 'react';
import { RawHTMLContent } from '@sparknz/journeys-common';
import { InformationLayer } from '@sparknz/spark-pattern-library';

import { useQuery } from 'shared/hooks';
import { useAuthorableContents } from 'shared/providers/AuthorableContentsProvider';

export default function PDPInfoLayer() {
  const { pushQuery, query, parseQueryValueString } = useQuery();
  const { getText } = useAuthorableContents();

  const infoLayerContentKey = parseQueryValueString('info');
  const isInfoLayerOpen = Boolean(infoLayerContentKey);

  const closeInfo = () => {
    const { info, ...params } = query;
    pushQuery(params);
  };

  return (
    <InformationLayer isOpen={isInfoLayerOpen} onClose={closeInfo}>
      <RawHTMLContent content={getText(infoLayerContentKey)} />
    </InformationLayer>
  );
}
